module.exports = __webpack_public_path__ + "static/media/google-analytics-logo.b1142f14.png";